import React, { forwardRef } from 'react';
import { cva } from 'class-variance-authority';

import { Image } from '../services/content';

import styles from './Radio.module.css';

export type RadioButtonProps = {
  value: string;
  name: string;
  isChecked: boolean;
  onChange: (value: string) => void;
  children: React.ReactNode;
  customIcon?: Image;
  className?: string;
};

const radioBase = cva(styles.radio, {
  variants: {
    isChecked: { true: styles.checked, false: '' },
  },
});

export const Radio = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ value, isChecked, name, onChange, customIcon, className, children, ...props }, ref) => {
    return (
      <label className={radioBase({ isChecked, className })}>
        <input
          ref={ref}
          type="radio"
          value={value}
          name={name}
          checked={isChecked}
          onChange={() => onChange(value)}
          className={styles.input}
          {...props}
        />
        {customIcon && <img src={customIcon.url} alt={customIcon.description} className={styles.icon} />}
        <span className={styles.label}>{children}</span>
      </label>
    );
  }
);
